// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_CATEGORY = "Kategorie";
export const BZ2_SEARCH_BUTTON = "Hledej";
export const BZ2_SUGGEST_CATEGORY_CATEGORY = "Doporu\u010den\u00e9 kategorie";
export const PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY = "Chci vybrat jinou kategorii, uka\u017e mi v\u0161echny...";
export const PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS = "Hled\u00e1m kategorii...";
